<footer>
  <div class="row">
    <div class="col-2" (press)="handleFirstPress()"></div>
    <div class="col-10" (press)="handleSecondPress()">
      <img src="assets/img/powered.png">
      <span class="mr-2">v.3.5</span>
    </div>
  </div>
</footer>
